module.exports = __webpack_public_path__ + "cfb343f1c20f851bfff6c2367748d011.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/decision-bg.png
 ** module id = 1548
 ** module chunks = 0
 **/